import { Platform } from "react-native";
import useDevice from "src/hooks/useDevice";
import IconMessages from "src/icons/IconMessages";
import useGlobalStore from "src/stores/useGlobalStore";
import ShareItem from "../../components/ShareItem";
import { ShareIMessageDataType } from "./shareIMessageHelpers";
import useShareIMessage from "./useShareIMessage";

const ShareIMessage = ({ data }: { data: ShareIMessageDataType }) => {
	const { handlePress, loading } = useShareIMessage(data);
	const { native } = useDevice();
	const isSmsAvailable = useGlobalStore((state) => state.isSmsAvailable);

	return (
		<ShareItem
			onPress={handlePress}
			Icon={IconMessages}
			name={Platform.OS === "ios" ? "iMessage" : "Messages"}
			disabled={!native || !isSmsAvailable}
			loading={loading}
		/>
	);
};
export default ShareIMessage;
